module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "el-menu-wrap",
    attrs: {
      "default-active": _vm.acitiveMenu,
      "collapse": _vm.collapsed,
      "unique-opened": "",
      "router": ""
    }
  }, _vm._l((_vm.routes), function(item) {
    return (!item.hidden) ? _c('items', {
      key: item.path,
      attrs: {
        "model": item,
        "parentPath": _vm.parentPath
      }
    }) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09df8608","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/conf/index/left.vue
// module id = 272
// module chunks = 123